module.exports = __webpack_public_path__ + "img/platform-C.b2de41ca.jpg";